export const LOCAL_FORAGE_KEY = '@___storage-1022';
export const RECOIL_STATE_KEY = '@___state-1022';
export const LOCAL_STORAGE_USER_EMAIL = '@___hshabsgnksb_bsb';
export const LOCAL_STORAGE_LAST_PROJECT = '@___last_p-hsgaggggagggag';
export const ISO_TIME_FORMAT = `yyyy-MM-dd'T'HH:mm:ss'Z'`
export const PROJECTS_IMAGE_FOLDER_NAME = `projectImages`
export const PROFILE_IMAGE_FOLDER_NAME = `profileImages`